window.featuredItemsCarousel = function featuredItemsCarousel() {

    var mobile_carousel = $('.gridWrap .js_mobileCarousel');

    if ($(window).width() > 670) {

        if (mobile_carousel.hasClass('slick-initialized')) {
            mobile_carousel.slick('unslick');
            // $('.js_fixHeight').matchHeight();
        }

    } else if (!mobile_carousel.hasClass('slick-initialized') && $('.gridWrap .js_mobileCarousel li').length > 0) {

        mobile_carousel.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            arrows: false,
            draggable: true,
            variableWidth: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 450,
                    settings: {
                        slidesToShow: 1,
                        cssEase: 'linear'
                    }
                }
            ]
        });
    }
}

$(document).ready(function () {
    'use strict';

    featuredItemsCarousel();
});

$(window).on('resize', debouncer(function (e) {
    'use strict';

    if ($('.gridWrap .featuredItems li').length) {
        featuredItemsCarousel();
    }
}));